import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class SelectBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.select;
        this.iframeBehaviorListeners = [{ type: this.id, listener: this.handler }];
    }
}
export default SelectBehavior;
